import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FenceDexie } from 'src/app/models/fence.model';
import { PaddockService } from 'src/app/services/paddock.service';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { DeleteFenceComponent } from './delete-fence/delete-fence.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-edit-fence',
    templateUrl: './edit-fence.component.html',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatDialogModule,MatFormFieldModule]
})
export class EditFenceComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EditFenceComponent>>(MatDialogRef);
  data = inject<{
    fence: FenceDexie;
}>(MAT_DIALOG_DATA);
  dialog = inject(MatDialog);
  paddockService = inject(PaddockService);


  wallabyProof = [
    { name: 'Yes', value: true, isChecked: false },
    { name: 'No', value: false, isChecked: false },
    { name: 'Unsure', value: null, isChecked: true },
  ];

  fenceState = [
    { label: 'Existing', value: true },
    { label: 'Planned', value: false },
  ];

  editFenceForm: UntypedFormGroup;

  ngOnInit(): void {
    this.dialogRef.disableClose = true;

    this.editFenceForm = new UntypedFormGroup(
      {
      'name': new UntypedFormControl(null, CustomValidators.required),
      'paddocks': new UntypedFormControl(null),
      'existing': new UntypedFormControl(null,CustomValidators.required)
      },
    );

    this.editFenceForm.get("paddocks").setValue(this.data.fence.paddocks);
    this.editFenceForm.get("existing").setValue(this.data.fence.existing);
    this.editFenceForm.get("name").setValue(this.data.fence.name)

  }



  openDeleteConfirmationDialog(){
    let confirmationDialog = this.dialog.open(DeleteFenceComponent,{data:this.data.fence.name});

    confirmationDialog.afterClosed().subscribe(result => {
      if(result)
      {
        this.dialogRef.close({deleteFence: true});
      }
      else
      {
        return;
      }
    })
    }

    updateFenceAndClose(){

    Object.assign(this.data.fence, this.editFenceForm.value);

    this.dialogRef.close(this.data.fence);
    }

}
